import { render, staticRenderFns } from "./Theme4Wrapper.vue?vue&type=template&id=0be8393b&"
import script from "./Theme4Wrapper.vue?vue&type=script&lang=js&"
export * from "./Theme4Wrapper.vue?vue&type=script&lang=js&"
import style0 from "./Theme4Wrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports